




























































































































































































































































































import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { Zakazka } from '@/modules/servis/zakazka';
import { Ozakazka } from '@/modules/servis/ozakazka';
import { editFactory } from '@/main/pages';
import { store } from '@/modules/sklad/PROrders/store/edit';
import { PROrdersParts as ProOrderParts } from '@/modules/sklad/PROrders/parts/index';
import { showAlert } from '@/main/utils/notifications';
import { mapActions } from 'vuex';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { apiProvider as PROrdersProvider, partsPurchaseOrderUrl, coDealerPurchaseReportUrl } from '@/modules/sklad/PROrders/api';
import { PAGE_MGR_CLEAR } from '@/main/store/actionTypes';
import { Dealer } from '@/modules/sklad/dealer';
import _, { toNumber } from 'lodash';
import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';
import { EditableStatus, ScreenSize } from '@/main/components/constants';
import { cellNames, CellNamesObject, convertToObjects, intToRgb, Row } from '@/main/utils/table';
import { DropdownItem } from '@/main/store/@types/dropdown';
import { apiProvider } from '@/modules/sklad/PROrders/parts/api';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import { END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { apiProvider as ndSkladApiProvider } from '../ndSklad/api';

import { PART_RETURN_REQUEST_STATUS, REPORT_FILE_TYPE } from '../constants';

import { NAME, DEPENDENT_TABLES, PROrdersParts, LOCALSTORAGE_STATE_KEY, EMAIL_STATUS, PARTS_COLS, TAB_NAMES, TABS,
	GENUINE_SUPPLIER_TYPE_ID, APPROVE_STATUS_ID, LOCAL_SUPPLIER_TYPE_ID, EDFSId, GRNId, 
	BULK_UPLOAD} from './constants';

import { editMutations } from './store/types';
import { ModelNv } from '@/modules/ciselnik/noveVozy/modelNv';


export default editFactory(NAME, store).extend({
	components: {
		DmsPdfDialog,
		SkladMistoSelect: SkladMisto.components.Select,
		ZakazkaSelect: Zakazka.components.Select,
		OzakazkaSelect: Ozakazka.components.Select,
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
		DodavatelSelect: Dodavatel.components.Select,
		DealerSelect: Dealer.components.Select,
		DropButtons,
		DmsEditableTable,
	},

	data() {
		return {
			lstPROrders: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null },
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			dependencies: {
				...DEPENDENT_TABLES,
				PROrdersParts,
			},
			showPartsPurchaseOrder: false as boolean,
			partsPurchaseOrderUrl,
			coDealerPurchaseReportUrl,
			tiskDialog: {
				visible: false,
				url: '',
				filter: null as {} | null,
				fetchPdfProvider: null as (() => Promise<any>) | null,
			},
			showPartsDialog: {
				visible: false,
				title: null as string | null,
				extraButtons: null as object | null,
				handleClose: () => { },
			},
			fileList: [] as any[],
			reportType: '' as string,
			quantitySum: 0 as number,
			amountSum: 0 as number,
			partsCols: PARTS_COLS,
			wearHouse: '',
			brand: '',
			partNumber: '',
			inputQuantity: '',
			cancelQuantity: '',
			inputUnitCostPrice: 0,
			cancelUnitCostPrice: 0,
			inputUnitCostPriceWithVat: 0,
			cancelUnitCostPriceWithVat: 0,
			inputDescription: '',
			cancelDescription: '',
			inputRemark: '',
			cancelRemark: '',
			inputVat: 0,
			cancelVat: 0,
			inputUnitPrice: 0,
			inputRRP: 0,
			cancelUnitPrice: 0,
			inputTotalCostPriceWithVat: 0,
			cancelTotalCostPriceWithVat: 0,
			isWareHouseDisabled: false,
			inputBaseUnitOfMeasurement:'',
			cancelBaseUnitOfMeasurement:'',
			inputUnitOfMeasurement:'',
			cancelUnitOfMeasurement:'',
			inputBaseQuantity:0,
			cancelBaseQuantity:0,
			conversionUnit:0,
			expandedUnit:'',
			VydejMjId: null as number | null,
			tabNames: TAB_NAMES,
			isApproved: false,
			selectedPartNumber: '',
			timeout: null as any | null,
			supplierType: null as number | null,
			IsPrOrder: false as boolean
		};
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		allowDelete(): boolean {
			return this.StatusId !== APPROVE_STATUS_ID;
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers(): Record<string, string> {
			return {
				dodavatel: `${this.storeUri}/${editMutations.PR_ORDERS_DODAVATEL_SELECT_MAPPER}`,
				dealer: `${this.storeUri}/${editMutations.PR_ORDERS_DEALER_SELECT_MAPPER}`,
			};
		},
		IsPROrderCreated():boolean {
			return this.Id === null || this.Id === undefined || this.Id < 0;
		},
		IsColumnDisabled():boolean {
			return [PART_RETURN_REQUEST_STATUS.DISABLE, PART_RETURN_REQUEST_STATUS.REJECT, PART_RETURN_REQUEST_STATUS.CLOSE].includes(this.StatusId);
		},
		showClosePR(): boolean {
			return this.StatusId === PART_RETURN_REQUEST_STATUS.CLOSE || this.isViewMode;
		},
		partPurchaseOrderFilter(): object {
			return {
				PrOrderId: this.Id,
			};
		},
		isRemarkRequired(): boolean {
			return this.StatusId === PART_RETURN_REQUEST_STATUS.DISABLE;
		},
		
		isDealerRequired(): boolean {
			return this.IsDealer !== null && this.IsDealer;
		},
		isSupplierRequired(): boolean {
			return !this.IsDealer;
		},
		showCreateButton() {
			return {
				ShowCreate: true,
			};
		},
		orderButtons(): object {
			this.lstPROrders = [
				{ labelKey: 'SUBMIT', click: 'onSubmitApproval', disable: this.DisableSubmit, exist: true },
				{ labelKey: 'PRINT_PR_ORDER', click: 'printPartsPurchaseOrder', disable: false, exist: this.ShowPrintButton && this.dmsSys.IndiaCFDPrp },
				{ labelKey: 'PR_ORDER_CLOSE', click: 'closePrOrder', disable: this.showClosePR, exist: true },
				{ labelKey: 'CO-DEALER-PURCHASE-REPORT', click: 'printCoDealerPurchaseReport', disable: false, exist: this.dmsSys.IndiaCFDPrp },
			];

			return this.lstPROrders
				.filter((item) => ((item.labelKey !== undefined && item.labelKey != null)) && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click); },
					exist: item.exist,
					disable: item.disable,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.dependentTables.PROrdersParts);
		},
		selectedRowId() : any[] | null {
			return this.selectedRow ? this.selectedRow[0] : null;
		},
		tableModel():{} {
			return {
				table: this.dependentTables.PROrdersParts,
				'select-row': this.selectedRowId,
			};
		},
		isSelectedWarehouseDisabled(): boolean {
			return this.isViewMode;
		},
		isPartsCreateExportDisabled(): boolean {
			return this.WarehouseId! < 1;
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	watch: {
		selectedPartNumber(newValue: any) {
		},
	},
	methods: {
		onPartNumberClick(row: Row) {
			OpenPartMaintenance({ cellNames: this.dependentTables.PROrdersParts.cellNames, row });
		},
		...mapActions({
			clearPages: `pageManager/${PAGE_MGR_CLEAR}`,
		}),
		call(method: any) {
			(this as { [key: string]: any })[method]();
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
			this.IsFileUploaded = !!file;
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
			this.IsFileUploaded = !!this.fileList.length;
		},
		async submitUpload() {
			const startTime = performance.now();
			this.startLoading();
			const result = await PROrdersProvider.uploadParts(this.fileList[0], this.Id, this.DodavatelId, this.OrderType!, this.WarehouseId);
			this.endLoading();
			const endTime = performance.now() - startTime;
			let seconds = parseFloat((endTime / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', 'PR Order', BULK_UPLOAD, seconds);
			this.fileList = [];
			if (result.data) {
				showAlert({
					message: result.data,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				await this.fetchTableSchemas();
				await this.fetchTableData();
			}
			this.showPartsDialog.visible = false;
			this.endLoading();
		},
		async validateOrderType() {
			if (this.OrderType === null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('OrderTypeValidation'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
				return false;
			}
			return true;
		},
		async showUploadPartsClick() {
			if (await this.validateOrderType() === false) {
				return;
			}
			const isValid = await this.validate();
			if (isValid) {
				if (this.Id <= 0) {
					this.edit.StatusId = PART_RETURN_REQUEST_STATUS.RAISE;
					const prOrderId = await PROrdersProvider.savePROrderData(this.edit);
					if (prOrderId instanceof Error) {
						this.endLoading();
						return;
					}
					if (this.isCreateMode && prOrderId.data > 0) {
						this.edit.Id = prOrderId.data;
					}
				}
				this.showPartsDialog.visible = true;
			}
		},
		tableCellStyle({ row, column }:{ row: Row, column: any }): any {
			if (column.label === this.LocalizePopisPoli('PART_RESERVE_STATUS')) {
				const rgb = intToRgb(row.cells[this.cellNamesCmp.PARTROWCOLOR]);
				return rgb ? { background: rgb, color: 'transparent' } : { color: 'transparent' };
			}
			return null;
		},
		async closeClick() {
			this.refreshPreviousPage = true;
			const checkFilters = true;
			openList(NAME, { checkFilters });
		},
		async saveClick() {
			if (await this.validateOrderType() === false) {
				return;
			}
			if (this.isCreateMode) {
				this.StatusId = PART_RETURN_REQUEST_STATUS.RAISE;
			}
			await this.updatePurchaseOrderDetails();
			const amountNumber = Number(this.amountSum);
			if (amountNumber > 0) {
				this.showConfirm({
					message: `${this.Localize('TOTALQUANTITY')} ${this.quantitySum} ${this.Localize('TOTALAMOUNT')} ${formatDecimalValue(amountNumber)}`,
					title: this.Localize('DMS3_SuccessTitle'),
					options: {
						cancelButtonText: this.Localize('Ne'),
						confirmButtonText: this.Localize('Ano'),
						callback: async (action) => {
							if (action === 'confirm') {
								const isValid = await this.validate();
								if (isValid) {
									this.startLoading();
									const prorderId = await PROrdersProvider.savePROrderData(this.edit);
									if (prorderId instanceof Error) {
										this.endLoading();
										return;
									}
									if (this.isCreateMode && prorderId.data > 0) {
										this.edit.Id = prorderId.data;
										this.ShowSubmitButton = true;
										this.HideApprovalFlag = true;
										await this.changeUrlToEdit(this.edit.Id);
										this.endLoading();
									} else {
										if (this.EmailStatusFlag === EMAIL_STATUS.SUBMIT && this.EmailStatusFlag !== null) {
											await PROrdersProvider.sendNotificationForPartsOrder(this.Id);
										}
										if (this.EmailStatusFlag !== EMAIL_STATUS.SUBMIT && this.EmailStatusFlag !== null) {
											await PROrdersProvider.sendNotificationForPartsOrderStatus(this.Id, this.EmailStatusFlag);
										}
										this.refreshPreviousPage = true;
										this.endLoading();
										this.openPROrderList(true);
									}
									await this.handlePartsSaveClick();
								}
							}
						},
					},
				});
			}
			else{
				await this.showErrorAlert({ message: this.LocalizeChyboveHlasky('savePoError') });
				}
		},
		clearSavedState() {
			window.localStorage.removeItem(LOCALSTORAGE_STATE_KEY);
		},
		async openPROrderList(checkFilters = true) {
			this.clearSavedState();
			await this.clearPages();
			openList(NAME, { checkFilters });
		},
		async onSubmitApproval() {
			const rowCount = this.dependentTables.PROrdersParts.rows.length;
			if (!rowCount || rowCount <= 0) {
				await this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS') });
				return;
			}
			if (this.Id > 0) {
				this.startLoading();
				const { data: supplierType } = await PROrdersProvider.getSupplierType(this.DodavatelId!);
				const { data: isEdfsEnabled } = await PROrdersProvider.isEdfsEnabled(this.WarehouseId!);
				this.supplierType = supplierType;
				if (supplierType && supplierType === GENUINE_SUPPLIER_TYPE_ID) {
					if (!isEdfsEnabled) {
						this.showConfirm({
							message: this.LocalizeChyboveHlasky('EdfsDisabledConfirmation'),
							title: this.Localize('DMS3_SuccessTitle'),
							options: {
								cancelButtonText: this.Localize('Ne'),
								confirmButtonText: this.Localize('Ano'),
								callback: async (action) => {
									if (action === 'confirm') {
										this.showConfirm({
											message: this.LocalizeChyboveHlasky('Confirm_PR_Order_Approval'),
											title: this.Localize('DMS3_SuccessTitle'),
											options: {
												cancelButtonText: this.Localize('Ne'),
												confirmButtonText: this.Localize('Ano'),
												callback: async (reply) => {
													if (reply === 'confirm') {
														this.approvePrOrder(isEdfsEnabled);
													}
												},
											},
										});
									}
								},
							},
						});
					} else {
						this.showConfirm({
							message: this.LocalizeChyboveHlasky('Confirm_PR_Order_Approval'),
							title: this.Localize('DMS3_SuccessTitle'),
							options: {
								cancelButtonText: this.Localize('Ne'),
								confirmButtonText: this.Localize('Ano'),
								callback: async (reply) => {
									if (reply === 'confirm') {
										this.approvePrOrder(isEdfsEnabled);
									}
								},
							},
						});
					}
				} else if (supplierType && supplierType === LOCAL_SUPPLIER_TYPE_ID) {
					this.approvePrOrder(isEdfsEnabled);
				}
				this.endLoading();
			} else { this.showMessage(this.LocalizeChyboveHlasky('Create_PR_Order')); }
		},
		showMessage(message: string) {
			showAlert({
				message,
				options: {
					type: 'info',
				},
			});
		},
		async loadedData() {
			this.startLoading();
			if (this.isCreateMode) {
				this.default();
			} else {
				await this.fetchTableSchemas();
				await this.entity();
				await this.fetchTableData();
			}
			if (!this.mainCollapse.length) {
				this.mainCollapse.push(PROrdersParts);
			}
			if (this.WarehouseId) {
				await this.getPartsList(this.WarehouseId);
			}
			this.endLoading();
			await this.updatePurchaseOrderDetails();
			if (!this.dependentTables.PROrdersParts.rows.length) {
				this.isWareHouseDisabled = false;
			} else {
				this.isWareHouseDisabled = true;
			}
		},
		async getPartsList(warehouseId: number) {
			this.startLoading();
			if (warehouseId) {
				const { data: result } = await apiProvider.getPartsList('', warehouseId);
				this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
				this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
			}
			this.endLoading();
		},
		async handleOnBillToWarehouseChange(billToWarehouseId: number) {
			await this.getKVPSWiseShipToWHList(billToWarehouseId);
		},
		async handleOnShipToWarehouseChange(shipToWarehouseId: number) {
			await this.getPartsList(shipToWarehouseId);
		},
		async onCheckClick(event: any) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				if (event.target.value.length > 2) {
					this.dropdownList.Parts = this.dropdownList.DefaultPartsList.filter((item: any) => item.Text.includes(event.target.value.toUpperCase()));
				}
			}, 800);
		},
		async approvePrOrder(isEdfsEnabled: boolean) {
			try {
				this.startLoading();
				if (this.supplierType === GENUINE_SUPPLIER_TYPE_ID) {
					if (isEdfsEnabled) {
						const { data: IsEdfsSubmited } = await PROrdersProvider.IsEdfsSubmited(this.Id!);
						if (!IsEdfsSubmited) {
                            const { data: inforamtion } = await PROrdersProvider.createEdfsSalesOrder(this.Id);
							showAlert({
								message: inforamtion.Message,
								title: `eDFS ${this.LocalizeChyboveHlasky('DMS3_InfoTitle')}`,
								options: { type: 'info', customClass: 'edfsMessageBox' },
							});
						}
					}
					await PROrdersProvider.approvePrOrder(this.Id);
					this.isApproved = true;
				} else if (this.supplierType === LOCAL_SUPPLIER_TYPE_ID) {
					await PROrdersProvider.approvePrOrder(this.Id);
					this.isApproved = true;
					this.IsDisableAddPart = true;
					this.DisableSubmit = true;
				}
			} catch (error) {
				this.logError(error as Error);
			} finally {
				this.entity();
				this.endLoading();
			}
		},
		async updatePurchaseOrderDetails() {
			let count = 0;
			this.amountSum = 0;
			this.quantitySum = 0;
			_.map(this.dependentTables.PROrdersParts.rows, () => {
				let amountRowIndex = 0;
				const partNumberRowIndex = this.dependentTables.PROrdersParts.cellNames!.MNOZSTVI_OBJ;
				const partNumberIndex :number = this.dependentTables.PROrdersParts.rows[count].cells[partNumberRowIndex]!;
				if (this.dmsSys.EnableGSTPrp) {
					amountRowIndex = this.dependentTables.PROrdersParts.cellNames!.TOTAL_COST_PRICE_WITH_GST;
				}
				if (this.dmsSys.EnableVATPrp) {
					amountRowIndex = this.dependentTables.PROrdersParts.cellNames!.TOTAL_COST_PRICE_WITH_VAT;
				}
				const amountIndex :number = this.dependentTables.PROrdersParts.rows[count].cells[amountRowIndex];
				this.quantitySum += +partNumberIndex;
				this.amountSum += +amountIndex;
				count += 1;
			});
		},
		refreshFun() {
			this.fetchTableData();
		},

		async editClick() {
			if (await this.validateOrderType() === false) {
				return;
			}
			const isValid = await this.validate();
			if (isValid) {
				if (this.Id <= 0) {
					this.edit.StatusId = PART_RETURN_REQUEST_STATUS.RAISE;
					const prorderId = await PROrdersProvider.savePROrderData(this.edit);
					if (prorderId instanceof Error) {
						this.endLoading();
						return;
					}
					if (this.isCreateMode && prorderId.data > 0) {
						this.edit.Id = prorderId.data;
						await this.changeUrlToEdit(this.edit.Id);
					}
					this.openNdObjednavkaEdit();
				}
				if (this.Id > 0) {
					this.openNdObjednavkaEdit();
				}
			}
		},
		openNdObjednavkaEdit() {
			openEdit(ProOrderParts.name, PageMode.CREATE, {
				filter: {
					fromSelectCreate: true,
					Id: this.Id,
					DodavatelId: this.DodavatelId,
					OrderType: this.OrderType,
					WarehouseId: this.WarehouseId,
				},
			});
		},
		openEditParts(event: any) {
			if (this.IsColumnDisabled) {
				showAlert({
					message: this.LocalizeChyboveHlasky('prEditPart'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			openEdit(ProOrderParts.name, PageMode.EDIT, { id: event.data.MIO_ID });
		},
		viewClick(event: any) {
			openEdit(ProOrderParts.name, PageMode.VIEW, { id: event.data.MIO_ID });
		},
		async onPrintPrOrder() {
			this.startLoading();
			this.getPROrderPFX();
			await PROrdersProvider.printPrOrderReceipt(this.Id);
			this.endLoading();
		},
		async closePrOrder() {
			this.startLoading();
			await PROrdersProvider.closePrOrder(this.Id);
			this.endLoading();
		},
		async getPROrderPFX() {
			await PROrdersProvider.getPROrderPFX(this.edit);
		},
		printCoDealerPurchaseReport() {
			this.tiskDialog.filter = { PrOrdersId: this.Id };
			this.tiskDialog.url = this.coDealerPurchaseReportUrl;
			this.tiskDialog.visible = true;
			this.reportType = REPORT_FILE_TYPE[REPORT_FILE_TYPE.PDF];
		},
		printPartsPurchaseOrder() {
			this.reportType = REPORT_FILE_TYPE[REPORT_FILE_TYPE.PDF];
			this.showPartsPurchaseOrder = true;
		},
		markReportAsPrinted() {
			PROrdersProvider.markReportAsPrinted(this.Id, this.reportType);
		},
		async createRow() {
			this.selectedPartNumber = '';
			await (this.$refs.editableTable as any).createRow();
		},
		updateRow(rowUpdateData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row }) {
			this.$store.commit(`${this.storeUri}/updateTableRow`, rowUpdateData);
		},

		async handleOnPartChange(val: string, row: Row, columnId: number) {
			this.startLoading();
			const partIndex: number = this.dependentTables.PROrdersParts.cellNames?.ND_NR!;
			row.cells[partIndex] = val;
			this.selectedPartNumber = val;
			const textIndex: any = this.dependentTables.PROrdersParts.cellNames?.TEXT;
			const remarkIndex: any = this.dependentTables.PROrdersParts.cellNames?.REMARK;
			const brandIndex: number = this.dependentTables.PROrdersParts.cellNames?.X_VYROBEKND_OZN!;
			const localRRPIndex: number = this.dependentTables.PROrdersParts.cellNames?.PART_MRP!;
			const partMrp = row.cells[localRRPIndex];
			const costPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE!;
			const costpriceDnp = row.cells[costPriceIndex];
			if (!_.isNil(val) && !_.isNil(this.WarehouseId)) {
				const { data: isObsoletePartStock } = await apiProvider.getisObsoletePartStock(val, this.WarehouseId, this.brand, 0);
				this.showObsoleteErrorMsg(isObsoletePartStock, row, partIndex);
			}
			const { data } = await ndSkladApiProvider.getPartDetails(val, '', this.OrderType!, this.DodavatelId!, this.WarehouseId);
			if(data.LocalRRP <= 0 && data.Ndp <= 0 ){
			if (!costpriceDnp || !partMrp) {
				this.endLoading();
				await this.showErrorAlert({ message: this.LocalizeChyboveHlasky('priceMissingCreatingPoError').replace('%PARTNUMBER%',this.selectedPartNumber) });
				return;
			}
			}
			let brand = data.VyrobekndOzn;
			this.brand = brand;
			this.VydejMjId = data.VydejMjId;
			const costPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE_WITH_VAT!;
			const vatIndex: number = this.dependentTables.PROrdersParts.cellNames?.VAT!;
			const ndpIndex: number = this.dependentTables.PROrdersParts.cellNames?.NDP!;
			
			const unit = await this.GetConversionUnitsForPart(val, brand!, this.WarehouseId!);
			if (unit) {
				const unitText = (this.dropdownList.VydejMjId.find((item: any) => item.Value === this.VydejMjId!) as any)?.Text ?? '';
				const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
				const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
				row.cells[baseUnitOfMeasurement] = `${unit} (${'1'} ${unit} ${'='} ${this.expandedUnit} ${unitText})`;
				this.inputBaseUnitOfMeasurement = row.cells[baseUnitOfMeasurement]
				row.cells[unitOfMeasurement] = unitText;
				this.inputUnitOfMeasurement = row.cells[unitOfMeasurement];
			}

			row.cells[costPriceWithVatIndex] = data.Ndp + (data.Ndp * data.VAT / 100);
			row.cells[costPriceIndex] = data.Ndp;
			row.cells[textIndex] = data.Text;
			row.cells[remarkIndex] = data.Remark;
			row.cells[vatIndex] = data.VAT;
			row.cells[ndpIndex] = data.Ndp;
			row.cells[localRRPIndex] = data.LocalRRP;
			this.inputDescription = data.Text;
			this.inputRemark = data.Remark;

			const totalCostPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE_WITH_VAT!;
			const totalCostPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE!;
			const qtyIndex: number = this.dependentTables.PROrdersParts.cellNames?.MNOZSTVI_OBJ!;

			row.cells[totalCostPriceWithVatIndex] = 0;
			row.cells[totalCostPriceIndex] = 0;
			row.cells[qtyIndex] = '';

			const wearHouseIndex: number = this.dependentTables.PROrdersParts.cellNames?.SHIP_TO_WH!;

			if (!row.cells[wearHouseIndex]) {
				row.cells[wearHouseIndex] = data.SkladOzn;
			}
			row.cells[brandIndex] = brand;
			this.endLoading();
		},
		async CopyhandleOnPartChange(value: string, row: Row, columnId: number) {
			this.startLoading();
			const partIndex: number = this.dependentTables.PROrdersParts.cellNames?.ND_NR!;
			 row.cells[partIndex] = this.selectedPartNumber;
			const textIndex: any = this.dependentTables.PROrdersParts.cellNames?.TEXT;
			const remarkIndex: any = this.dependentTables.PROrdersParts.cellNames?.REMARK;
			const brandIndex: number = this.dependentTables.PROrdersParts.cellNames?.X_VYROBEKND_OZN!;
			const localRRPIndex: number = this.dependentTables.PROrdersParts.cellNames?.PART_MRP!;
			const partMrp = row.cells[localRRPIndex];
			const costPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE!;
			const costpriceDnp = row.cells[costPriceIndex];
			if (!_.isNil(this.selectedPartNumber) && !_.isNil(this.WarehouseId)) {
				const { data: isObsoletePartStock } = await apiProvider.getisObsoletePartStock(this.selectedPartNumber, this.WarehouseId, this.brand, 0);
				this.showObsoleteErrorMsg(isObsoletePartStock, row, partIndex);
			}
			const { data } = await ndSkladApiProvider.getPartDetails(this.selectedPartNumber, '', this.OrderType!, this.DodavatelId!, this.WarehouseId);
			if(data.LocalRRP <= 0 && data.Ndp <= 0 ) {
				if (!costpriceDnp || !partMrp) {
					this.endLoading();
					await this.showErrorAlert({ message: this.LocalizeChyboveHlasky('priceMissingCreatingPoError').replace('%PARTNUMBER%',this.selectedPartNumber) });
					return;
				}
			}
			let brand = data.VyrobekndOzn;
			this.brand = brand;
			this.VydejMjId = data.VydejMjId;
			const costPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE_WITH_VAT!;
			const vatIndex: number = this.dependentTables.PROrdersParts.cellNames?.VAT!;
			const ndpIndex: number = this.dependentTables.PROrdersParts.cellNames?.NDP!;
			const unit = await this.GetConversionUnitsForPart(this.selectedPartNumber, brand!, this.WarehouseId!);
			if (unit) {
				const unitText = (this.dropdownList.VydejMjId.find((item: any) => item.Value === this.VydejMjId!) as any)?.Text ?? '';
				const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
				const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
				row.cells[baseUnitOfMeasurement] = `${unit} (${'1'} ${unit} ${'='} ${this.expandedUnit} ${unitText})`;
				this.inputBaseUnitOfMeasurement = row.cells[baseUnitOfMeasurement]
				row.cells[unitOfMeasurement] = unitText;
				this.inputUnitOfMeasurement = row.cells[unitOfMeasurement];
			}
			row.cells[costPriceWithVatIndex] = data.Ndp + (data.Ndp * data.VAT / 100);
			row.cells[costPriceIndex] = data.Ndp;
			row.cells[textIndex] = data.Text;
			row.cells[remarkIndex] = data.Remark;
			row.cells[vatIndex] = data.VAT;
			row.cells[ndpIndex] = data.Ndp;
			row.cells[localRRPIndex] = data.LocalRRP;
			this.inputDescription = data.Text;
			this.inputRemark = data.Remark;
			const totalCostPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE_WITH_VAT!;
			const totalCostPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE!;
			const qtyIndex: number = this.dependentTables.PROrdersParts.cellNames?.MNOZSTVI_OBJ!;
			const wearHouseIndex: number = this.dependentTables.PROrdersParts.cellNames?.SHIP_TO_WH!;
			if (!row.cells[wearHouseIndex]) {
				row.cells[wearHouseIndex] = data.SkladOzn;
			}
			row.cells[brandIndex] = brand;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;
			this.inputVat = row.cells[vatIndex];
			row.cells[totalCostPriceWithVatIndex] = row.cells[costPriceWithVatIndex] * row.cells[qtyIndex]!;
			this.inputTotalCostPriceWithVat = row.cells[totalCostPriceWithVatIndex];
			this.inputUnitCostPriceWithVat = row.cells[costPriceWithVatIndex];
			row.cells[totalCostPriceIndex] = row.cells[costPriceIndex] * row.cells[qtyIndex]!;
			this.inputUnitCostPrice = row.cells[costPriceIndex] * row.cells[qtyIndex]!;
			this.inputUnitPrice = row.cells[costPriceIndex];
			row.cells[baseQuantity] = (row.cells[qtyIndex]! * unit);
			this.inputBaseQuantity = row.cells[baseQuantity];
			this.inputRRP = row.cells[localRRPIndex] ;
			this.endLoading();
		},
		async showObsoleteErrorMsg(isObsoletePartStock: any, newRow: Row, ndNrIndex: number) {
			if (isObsoletePartStock.IsObsoletePart) {
				if (!_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					const replacement = [{
						key: '<SUPERSEDED_PART_NUMBER>',
						value: isObsoletePartStock.SupersededPartNumber,
					},
					{
						key: '<SUPERSEDED_DATE>',
						value: isObsoletePartStock.SupersededDate,
					}];
					const confirmChangePart = await this.showConfirm({
						message: this.LocalizeAndReplaceMultiple(
							this.LocalizeChyboveHlasky('msgPartObsoleteSuperseded'),
							replacement,
						),
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
							closeOnPressEscape: false,
							closeOnClickModal: false,
						},
					});
					if (confirmChangePart) {
						this.startLoading();
						newRow.cells[ndNrIndex] = isObsoletePartStock.SupersededPartNumber;
						this.selectedPartNumber = isObsoletePartStock.SupersededPartNumber;
						this.handleOnPartChange(isObsoletePartStock.SupersededPartNumber, newRow, ndNrIndex);
						this.endLoading();
					} else {
						newRow.cells[ndNrIndex] = '';
						this.selectedPartNumber = '';
					}
				} else if (_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					newRow.cells[ndNrIndex] = '';
					this.selectedPartNumber = '';
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('msgIsObsoleteQuantityNotAvailable'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				}
			}
		},
		getCellDetails(row: Row, columnId: number) {
			return row.cells[columnId];
		},

		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.PROrdersParts.rows = rows;
		},
		async GetConversionUnitsForPart(partNumber: string, brand: string, wearHouse: number) {
			const { data } = await apiProvider.getConversionUnits(partNumber, wearHouse, brand);
			this.expandedUnit = data.ExpandedUnit;
			this.conversionUnit = data.ExpandedUnit;
			return data.UnitOfMeasure;
		},

		async rowSaved({ row: newRow }: { row: Row }) {
			this.isWareHouseDisabled = true;
			const quantityIndex: number = this.dependentTables.PROrdersParts.cellNames?.MNOZSTVI_OBJ!;
			const qty = newRow.cells[quantityIndex];
			if (!qty || qty <= 0) {
				await this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS') });
				return;
			}
			const localRRPIndex: number = this.dependentTables.PROrdersParts.cellNames?.PART_MRP!;
			const unitPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE!;
			const partIndex: number = this.dependentTables.PROrdersParts.cellNames?.ND_NR!;
			newRow.cells[partIndex] = this.selectedPartNumber;
			const costPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE!;
			const TotalCostPriceWithVATIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE_WITH_VAT!;
			const costPriceWithVATIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE_WITH_VAT!;
			newRow.cells[costPriceWithVATIndex] = this.inputUnitCostPriceWithVat;
			newRow.cells[TotalCostPriceWithVATIndex] = this.inputTotalCostPriceWithVat;
			newRow.cells[costPriceIndex] = this.inputUnitCostPrice;
			const textIndex: any = this.dependentTables.PROrdersParts.cellNames?.TEXT;
			newRow.cells[textIndex] = this.inputDescription;
			const remarkIndex: any = this.dependentTables.PROrdersParts.cellNames?.REMARK;
			newRow.cells[remarkIndex] = this.inputRemark;
			const vatIndex: number = this.dependentTables.PROrdersParts.cellNames?.VAT!;
			newRow.cells[vatIndex] = this.inputVat;
			newRow.cells[unitPriceIndex] = this.inputUnitPrice;
			newRow.cells[localRRPIndex] = this.inputRRP;
			const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
			newRow.cells[baseUnitOfMeasurement] = this.inputBaseUnitOfMeasurement;
			const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
			newRow.cells[unitOfMeasurement] = this.inputUnitOfMeasurement;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;
			newRow.cells[baseQuantity] = this.inputBaseQuantity;
			const brandIndex: number = this.dependentTables.PROrdersParts.cellNames?.X_VYROBEKND_OZN!;
			if (this.brand !== '')
			{
				newRow.cells[brandIndex] = this.brand;
			}
		},

		onDescriptionInput(event: any, row: Row, columnId: number) {
			const descIndex: number = this.dependentTables.PROrdersParts.cellNames?.TEXT!;
			row.cells[descIndex] = event!;
			this.inputDescription = row.cells[descIndex];
		},

		onRemarkInput(event: any, row: Row, columnId: number) {
			const remarkTextIndex: number = this.dependentTables.PROrdersParts.cellNames?.REMARK!;
			row.cells[remarkTextIndex] = event!;
			this.inputRemark = row.cells[remarkTextIndex];
		},

		onTextInput(event: any, row: Row, columnId: number, updateCol: any) {
			updateCol(event, columnId);
			const quantityIndex: number = this.dependentTables.PROrdersParts.cellNames?.MNOZSTVI_OBJ!;
			row.cells[quantityIndex] = event!;
			const totalCostPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE_WITH_VAT!;
			const costPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE_WITH_VAT!;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;

			const totalCostPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE!;
			const costPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE!;
			const vatIndex: number = this.dependentTables.PROrdersParts.cellNames?.VAT!;
			this.inputVat = row.cells[vatIndex];
			row.cells[totalCostPriceWithVatIndex] = row.cells[costPriceWithVatIndex] * event!;
			this.inputTotalCostPriceWithVat = row.cells[totalCostPriceWithVatIndex];
			this.inputUnitCostPriceWithVat = row.cells[costPriceWithVatIndex];
			row.cells[totalCostPriceIndex] = row.cells[costPriceIndex] * event!;
			this.inputUnitCostPrice = row.cells[costPriceIndex] * event!;
			this.inputUnitPrice = row.cells[costPriceIndex];
			row.cells[baseQuantity] = (event! * this.conversionUnit);
			this.inputBaseQuantity = row.cells[baseQuantity];
			
		},
		async handleOnWearhouseChange(val: string, row: Row) {
			this.wearHouse = val;

			this.dropdownList.Parts = [];
			const brandIndex: number = this.dependentTables.PROrdersParts.cellNames?.X_VYROBEKND_OZN!;
			row.cells[brandIndex] = '';
			const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
			const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;
			row.cells[baseUnitOfMeasurement] = '';
			row.cells[unitOfMeasurement] = '';
			row.cells[baseQuantity] = 0;

			await this.setDefaultRowValues(row);
		},
		async setDefaultRowValues(row: Row) {
			const totalCostPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE_WITH_VAT!;
			const totalCostPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE!;
			const qtyIndex: number = this.dependentTables.PROrdersParts.cellNames?.MNOZSTVI_OBJ!;
			const textIndex: any = this.dependentTables.PROrdersParts.cellNames?.TEXT;
			const remarkIndex: any = this.dependentTables.PROrdersParts.cellNames?.REMARK;
			const localRRPIndex: number = this.dependentTables.PROrdersParts.cellNames?.PART_MRP!;
			const unitPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE!;
			const vatIndex: number = this.dependentTables.PROrdersParts.cellNames?.VAT!;
			const costPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE_WITH_VAT!;
			const claimTypeIndex: number = this.dependentTables.PROrdersParts.cellNames?.POHLEDAVKA_PZN!;
			const answerTypeIndex: number = this.dependentTables.PROrdersParts.cellNames?.ODPOVED_PZN!;
			const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
			const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;

			row.cells[textIndex] = '';
			row.cells[remarkIndex] = '';
			row.cells[claimTypeIndex] = '';
			row.cells[answerTypeIndex] = '';
			row.cells[totalCostPriceWithVatIndex] = 0;
			row.cells[totalCostPriceIndex] = 0;
			row.cells[qtyIndex] = 0;
			row.cells[localRRPIndex] = 0;
			row.cells[unitPriceIndex] = 0;
			row.cells[vatIndex] = 0;
			row.cells[costPriceIndex] = 0;
			row.cells[baseUnitOfMeasurement]='';
			row.cells[unitOfMeasurement]='';
			row.cells[baseQuantity]=0;
		},
		async handleOnCategoryChange(val: string, row: Row) {
			this.startLoading();
			this.brand = val;

			const wearHouseIndex: number = this.dependentTables.PROrdersParts.cellNames?.SHIP_TO_WH!;
			let wearHouse = row.cells[wearHouseIndex];
			const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
			const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;
			row.cells[baseUnitOfMeasurement]='';
			row.cells[unitOfMeasurement]='';
			row.cells[baseQuantity]=0;

			if (!wearHouse) {
				wearHouse = this.wearHouse;
			}
			await this.setDefaultRowValues(row);
			if (this.dropdownList.DefaultPartsList === undefined || this.dropdownList.DefaultPartsList.length === 0) {
				const { data: result } = await apiProvider.getPartsList(val, wearHouse);
				this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
				this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
			}
			this.endLoading();
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }): Promise<void> {
			if (this.DisableSubmit) {
				await this.showErrorAlert({ message: 'prEditPart' });
				await this.fetchTableData();
				(this.$refs.table as any).refreshLayout();
				return;
			}
			this.startLoading();
			const quantityIndex: number = this.dependentTables.PROrdersParts.cellNames?.MNOZSTVI_OBJ!;
			const costPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE_WITH_VAT!;
			const textIndex: number = this.dependentTables.PROrdersParts.cellNames?.TEXT!;
			const remarkIndex: number = this.dependentTables.PROrdersParts.cellNames?.REMARK!;
			const totalCostPriceWithVatIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE_WITH_VAT!;
			const vatIndex: number = this.dependentTables.PROrdersParts.cellNames?.VAT!;
			const unitPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.COST_PRICE!;
			const totalCostPriceIndex: number = this.dependentTables.PROrdersParts.cellNames?.TOTAL_COST_PRICE!;
		    const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
			const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
			const baseQuantity: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_QUANTITY!;

			this.inputQuantity = row.cells[quantityIndex];
			this.cancelQuantity = row.cells[quantityIndex];
			this.inputUnitCostPrice = row.cells[costPriceIndex];
			this.cancelUnitCostPrice = row.cells[costPriceIndex];
			this.inputDescription = row.cells[textIndex];
			this.cancelDescription = row.cells[textIndex];
			this.inputRemark = row.cells[remarkIndex];
			this.cancelRemark = row.cells[remarkIndex];
			this.inputUnitCostPriceWithVat = row.cells[totalCostPriceIndex];
			this.cancelUnitCostPriceWithVat = row.cells[totalCostPriceIndex];
			this.inputVat = row.cells[vatIndex];
			this.cancelVat = row.cells[vatIndex];
			this.inputUnitPrice = row.cells[unitPriceIndex];
			this.cancelUnitPrice = row.cells[unitPriceIndex];
			this.inputTotalCostPriceWithVat = row.cells[totalCostPriceWithVatIndex];
			this.cancelTotalCostPriceWithVat = row.cells[totalCostPriceWithVatIndex];
			this.inputBaseUnitOfMeasurement = row.cells[baseUnitOfMeasurement];
			this.cancelBaseUnitOfMeasurement = row.cells[baseUnitOfMeasurement];
			this.inputUnitOfMeasurement = row.cells[unitOfMeasurement];
			this.cancelUnitOfMeasurement = row.cells[unitOfMeasurement];
			this.inputBaseQuantity = row.cells[baseQuantity];
			this.cancelBaseQuantity = row.cells[baseQuantity];
			const brandIndex: number = this.dependentTables.PROrdersParts.cellNames?.X_VYROBEKND_OZN!;
			let brand = row.cells[brandIndex];
			if (!brand) {
				brand = this.brand;
			}

			const wearHouseIndex: number = this.dependentTables.PROrdersParts.cellNames?.SHIP_TO_WH!;
			let wearHouse = row.cells[wearHouseIndex];
			if (!wearHouse) {
				wearHouse = this.wearHouse;
			}
			const partNumberIndex: number = this.dependentTables.PROrdersParts.cellNames?.ND_NR!;
			let partNumber = row.cells[partNumberIndex];
			if (!partNumber) {
				partNumber = this.partNumber;
			}
			this.selectedPartNumber = partNumber;
			if (this.dropdownList.DefaultPartsList === undefined || this.dropdownList.DefaultPartsList.length === 0) {
				const { data: result } = await apiProvider.getPartsList(brand, wearHouse);
				this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
				this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
			}
			const unit = await this.GetConversionUnitsForPart(partNumber, brand!, this.WarehouseId!);
			if (unit) {
				const unitText = (this.dropdownList.VydejMjId.find((item: any) => item.Value === this.VydejMjId!) as any)?.Text ?? '';
				const baseUnitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
				const unitOfMeasurement: number = this.dependentTables.PROrdersParts.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
				row.cells[baseUnitOfMeasurement] = `${unit} (${'1'} ${unit} ${'='} ${this.expandedUnit} ${unitText})`;
				row.cells[unitOfMeasurement] = unitText;
			}


			this.endLoading();
		},
		getAnswerType(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.OdpovedPzn.find((item: any) => item.Value === row.cells[columnId])!;
			return result?.Text ?? row.cells[columnId];
		},
		getClaimType(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.PohledavkaPzn.find((item: any) => item.Value === row.cells[columnId])!;
			return result?.Text ?? row.cells[columnId];
		},
		getPartType(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.Parts.find((item: any) => item.Value === row.cells[columnId])!;
			return result?.Value ?? row.cells[columnId];
		},

		getWearHouse(row: Row, columnId: number) {
			if (this.dropdownList.SkladOzn.length > 0) {
				const result: DropdownItem = this.dropdownList.SkladOzn.find((item: any) => item.Value === row.cells[columnId])!;
				return result?.Text ?? this.ShipToWarehouse;
			}
			return this.getWearHouseNameById(row.cells[columnId]);
		},
		getWearHouseNameById(Id: null | number) {
			if (Id) {
				const result: DropdownItem = this.dropdownList.BillToWarehouseList.find((item: any) => item.Value === Id)!;
				return result?.Text;
			}
			return '';
		},
		
		getSelectedWareHouse(row: Row, columnId: number) {
			const wareHouseIndex: number = this.dependentTables.PROrdersParts.cellNames?.SHIP_TO_WH!;
			row.cells[wareHouseIndex] = this.WarehouseId;
			if (this.dropdownList.SkladOzn.length > 0) {
				const result: DropdownItem = this.dropdownList.SkladOzn.find((item: any) => item.Value === this.WarehouseId)!;
				return result?.Text ?? this.ShipToWarehouse;
			}
			return this.getWearHouseNameById(this.WarehouseId);
		},

		getCategory(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.VyrobekndOzn.find((item: any) => item.Value === row.cells[columnId])!;
			return result?.Text ?? row.cells[columnId];
		},

		async handlePartsSaveClick() {
			if (this.IsColumnDisabled) {
				return;
			}
			let count = 0;

			const partsData = convertToObjects(this.dependentTables.PROrdersParts).map((part, idx) => {
				if (part.ReceiptId < 0) {
					part.ReceiptId = 0;
				}

				part.MioId = part.ReceiptId;

				if (!part.OdpovedPzn) {
					part.OdpovedPzn = 0;
				}

				if (!part.PohledavkaPzn) {
					part.PohledavkaPzn = 0;
				}

				if (!part.MnozstviObjKor) {
					part.MnozstviObjKor = 0;
				}

				part.PrOrdersId = this.Id;
				const orderResult: DropdownItem = this.dropdownList.VyrobekndOzn.find((item: any) => item.Text === part.XVyrobekndOzn)!;
				const categoryResult: DropdownItem = this.dropdownList.SkladOzn.find((item: any) => item.Text === part.XSkladOzn)!;

				part.VyrobekndOzn = orderResult?.Value ?? part.XVyrobekndOzn;
				part.SkladOzn = categoryResult?.Value ?? part.XSkladOzn;
				part.MnozstviObj = +part.MnozstviObj;


				if (!part.PrOrdersId || !part.NdNr || !part.VyrobekndOzn || !part.Text || !part.SkladOzn || !part.MnozstviObj || part.MnozstviObj <= 0) {
					count += 1;
				}
				return ({ ...part });
			});

			if (count > 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS') });
				return;
			}

			this.startLoading();

			await PROrdersProvider.savePartsPOGrid(partsData);

			this.endLoading();

			await this.fetchTableData();
		},
		async deleteRow(item: any) {
			if (this.DisableSubmit) {
				await this.showErrorAlert({ message: 'prEditPart' });

				await this.fetchTableData();
				(this.$refs.table as any).refreshLayout();
			}

			let confirmDelete = true;
			confirmDelete = await this.showConfirm({
				message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
				title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});

			if (confirmDelete) {
				if (this.dependentTables.PROrdersParts.rows.length < 1) { this.isWareHouseDisabled = false; }
				apiProvider.deleteEntity(item.rowId);
			} else {
				await this.fetchTableData();
				(this.$refs.table as any).refreshLayout();
			}
		},
		async enableSubmit() {
			this.startLoading();
			const { data: IsEdfsSubmited } = await PROrdersProvider.EnableSubmit(this.Id!);
			this.endLoading();
			if(IsEdfsSubmited.includes(EDFSId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('EnableSubmitMSG') + IsEdfsSubmited,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
				return false;
			}
			if(IsEdfsSubmited.includes(GRNId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('GRNAlreadyCreated') + IsEdfsSubmited,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
				return false;
			}
			this.DisableSubmit = false;
		},


		async getKVPSWiseShipToWHList(value: number) {
			this.WarehouseId = null;
			this.ShipToWarehouse = null;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			if (value) {
				const { data: shipToList } = await PROrdersProvider.getBillToWHWiseShipToWH(value);
				this.dropdownList.WarehouseId = shipToList;
				this.dropdownList.SkladOzn = shipToList;
				if (!this.dropdownList.WarehouseId.length) {
					this.ShipToWarehouse = this.getWearHouseNameById(value);
					this.WarehouseId = value;
					await this.getPartsList(this.WarehouseId);
				} else {
					const [firstWareHouse, secondWareHouse] = this.dropdownList.WarehouseId;
					if (secondWareHouse === undefined) {
						const { Value } = firstWareHouse;
						this.WarehouseId = Value;
						await this.getPartsList(this.WarehouseId);
					}
				}
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
	},
});
